import React, { useState, useEffect, useRef } from "react";
import FolderItemForReordering from "./FolderItemForReordering";
import MovingLocator from "./MovingLocator";


export default function FoldersReorderer(props) {
  const { currentlyViewing, handleRearrange, type } = props;
  const [itemStartingHeights, setItemStartingHeights] = useState([[0]]);
  const [movingLocator, setMovingLocator] = useState([false, 0, 0, 100])
  const [opacity, setOpacity] = useState(1)
  const [isInitialized, setIsInitialized] = useState(false);
  const currentlyViewingRef = useRef(currentlyViewing);
  const groupWidth = window.innerWidth * 0.3;

    // Function to initialize blockStartingHeights based on blocks
    useEffect(() => {
      const initializeItemStartingHeights = () => {
        const initialStartingHeights = [0]; // Initialize empty columns
        for (let i = 1; i <= currentlyViewingRef.current.length; i++) {
            initialStartingHeights.push(70*i)
        }
        setItemStartingHeights(initialStartingHeights);
        setIsInitialized(true); // Set initialized to true once setup is complete
      };
    
      if (!isInitialized && currentlyViewingRef.current.length > 0) {
        initializeItemStartingHeights();
      }
    }, [currentlyViewing, isInitialized]);

    useEffect(() => {
        currentlyViewingRef.current = currentlyViewing;
    }, [currentlyViewing]);

  function handleItemMove(itemId, itemType, itemOldOrder, desiredOrder) {
    handleRearrange(itemId, itemType, itemOldOrder, desiredOrder); //function in manager to handle movements
  }

  function createLocator (height, start, width) {
    setMovingLocator([true, height, start, width]);
  }
  function endLocator(){
    setMovingLocator([false, 0, 0, 100])
  }
  return (
    <div className="group-container" style={{width: groupWidth, left: window.innerWidth * 0.3}} id="reorderer">
      <div className="group-content" style={{width: groupWidth}}>
        <div
          className="block group"
          style={{height: currentlyViewing.length * 60, 
            width: groupWidth
          }}
        >
          <div className="block-inner">
            <div className="block-content">
              <MovingLocator what={movingLocator}/>
              {isInitialized && currentlyViewing.map((item, index) => {
                return (<FolderItemForReordering
                key={index}
                item={item}
                order={item.order}
                maxWidth={groupWidth - 12}
                startingHeight={itemStartingHeights[item.order]}
                overallStartingHeights={itemStartingHeights}
                height={50}
                onRearrange={handleItemMove}
                createLocator={createLocator}
                endLocator={endLocator}
                opacity={opacity}
                setOpacity={setOpacity}
                type={type}
              />)})}
            </div>
          </div>
        </div>
      </div>
      <div style={{height: "200px"}}></div>
    </div>
  );
}